import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-textarea',
  standalone: true,
  imports: [FormsModule],
  template: `
    <label class="cg-admin-field" [class.cg-admin-field--full]="fullWidth()">
      @if (label()) {
        <span class="cg-admin-field__label">{{ label() }}</span>
      }
      <textarea
        class="cg-textarea"
        [class.font-mono]="mono()"
        [class.text-xs]="mono()"
        [attr.name]="name() || null"
        [rows]="rows()"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [(ngModel)]="value"
      ></textarea>
      @if (help()) {
        <span class="cg-form-help">{{ help() }}</span>
      }
      @if (error()) {
        <span class="cg-form-error">{{ error() }}</span>
      }
    </label>
  `,
})
export class AdminTextareaComponent {
  readonly label = input<string>();
  readonly name = input<string>();
  readonly rows = input(3);
  readonly placeholder = input('');
  readonly help = input<string>();
  readonly error = input<string>();
  readonly mono = input(false);
  readonly fullWidth = input(false);
  readonly disabled = input(false);
  readonly value = model<string>('');
}
